import type { ReactElement } from 'react'

import type { TypeSectionContentItems } from '@contentful-types/section'
import type { TypeSectionMultiColumnEntry } from '@contentful-types/section-multi-column'

import { CtaDescriptionPosition } from '@constants/enums/cta'

import {
  CtaButtonMetadataProvider,
  DefaultCtaButtonContext,
} from '../../../contexts/cta-button-context'
import { MultiColumnLayout } from '../../layout/multi-column/multi-column'
import { PageSection } from '../../page-core/section/page-section'
import { ContentRenderer } from '../../renderer'

function MultiColumnSectionContent(entry: TypeSectionMultiColumnEntry): ReactElement {
  const {
    maxColumnsPerRow,
    minColumnsPerRow,
    showDividersBetweenColumns,
    columns,
    multiColumnAsSingle,
    compact,
  } = entry.fields

  return (
    <MultiColumnLayout
      multiColumnAsSingle={multiColumnAsSingle}
      maxColumnsPerRow={maxColumnsPerRow}
      minColumnsPerRow={minColumnsPerRow}
      withDivider={showDividersBetweenColumns}
      compact={compact}
    >
      {columns?.map((column, i) => (
        <div key={`${column!.sys.id}-${i}`}>
          <ContentRenderer data={column!.fields.content as TypeSectionContentItems[]} />
        </div>
      ))}
    </MultiColumnLayout>
  )
}

export function MultiColumnSection({
  data,
}: {
  className?: string
  data: TypeSectionMultiColumnEntry
}): ReactElement {
  const {
    sys,
    fields: { internalName, background, heading, multiColumnAsSingle },
  } = data

  const multiColumnContent = (
    <CtaButtonMetadataProvider
      value={{ ...DefaultCtaButtonContext, descriptionPosition: CtaDescriptionPosition.Left }}
    >
      <MultiColumnSectionContent {...data} />
    </CtaButtonMetadataProvider>
  )

  if (multiColumnAsSingle) {
    return multiColumnContent
  }

  return (
    <PageSection
      internalName={internalName}
      sysStructure={sys}
      heading={heading}
      background={background}
    >
      {multiColumnContent}
    </PageSection>
  )
}

export function MultiColumnSectionForTabs(): string {
  return 'PLACEHOLDER: multi column section for tabs'
}
